import { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { getTimeLeftFromDateTime } from "~/utils/helper-funcations";
import useRemainingTime from "~/hook/useRemainingTime";

dayjs.extend(duration);

interface QuizCountdownProps {
  date: string; // e.g., "2025-07-20"
  startTime: string; // e.g., "14:30"
  onComplete?: () => void;
  setIsStartTimeOver?: (isOver: boolean) => void;
}

const QuizCountdown = ({ date, startTime, onComplete, setIsStartTimeOver }: QuizCountdownProps) => {
  const { remainingTime, formattedHHMMSS } = useRemainingTime(date, startTime);

  useEffect(() => {
    if (remainingTime.totalSeconds <= 0) {
      onComplete?.();
      setIsStartTimeOver?.(true);
    }
  }, [remainingTime]);

  return <span className="font-mono text-lg text-textColor">{formattedHHMMSS}</span>;
};

export default QuizCountdown;
